export const isServerSide = typeof window === 'undefined'
